import { render, staticRenderFns } from "./DigitalCountByTypeChart.vue?vue&type=template&id=915b64aa&scoped=true&"
import script from "./DigitalCountByTypeChart.vue?vue&type=script&lang=js&"
export * from "./DigitalCountByTypeChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "915b64aa",
  null
  
)

export default component.exports